import AdminDashboard     from "./role/AdminDashboard";
import TeacherDashboard   from "./role/TeacherDashboard";
import StudentDashboard   from "./role/StudentDashboard";
import ParentDashboard    from "./role/ParentDashboard";
import JanitorDashboard   from "./role/JanitorDashboard";
import GuardDashboard     from "./role/GuardDashboard";
import CashierDashboard   from "./role/CashierDashboard";
import RegistrarDashboard from "./role/RegistrarDashboard";
import LibrarianDashboard from "./role/LibrarianDashboard";
import NurseDashboard     from "./role/NurseDashboard";
import GenericStaffDashboard from "./role/GenericStaffDashboard";

function getUser() {
  try {
    return JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user") || "null");
  } catch { return null; }
}

const ROLE_DASHBOARDS = {
  // SuperDev (project developer, hidden role) lands on the same rich
  // AdminDashboard so they can audit the whole system at a glance.
  SuperDev:       AdminDashboard,
  SuperAdmin:     AdminDashboard,
  Admin:          AdminDashboard,
  // Academic Head's daily work is closing the unassigned-teachers and
  // uncovered-subjects gaps, which is exactly what AdminDashboard surfaces.
  AcademicHead:   AdminDashboard,
  ContentManager: GenericStaffDashboard,
  Teacher:        TeacherDashboard,
  Student:        StudentDashboard,
  Parent:         ParentDashboard,
  Janitor:        JanitorDashboard,
  SecurityGuard:  GuardDashboard,
  Registrar:      RegistrarDashboard,
  Cashier:        CashierDashboard,
  HR:             GenericStaffDashboard,
  Librarian:      LibrarianDashboard,
  Nurse:          NurseDashboard,
  GuidanceOffice: GenericStaffDashboard,
  RegistrarStaff: RegistrarDashboard,
  CashierStaff:   CashierDashboard,
  // Library / Clinic staff inherit their lead's premium dashboard — the
  // data scope is the same; their write permissions are gated separately.
  LibraryStaff:   LibrarianDashboard,
  ClinicStaff:    NurseDashboard,
};

export default function DashboardPage() {
  const user = getUser();
  const Dashboard = ROLE_DASHBOARDS[user?.role] || GenericStaffDashboard;
  return <Dashboard user={user} />;
}
